import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import GET_COVEO_AUTHENTICATION from './GetCoveoAuthentication.gql';

const parseResult = (result) => {
  const initialState = {
    token: '',
  };

  const tokenInfo = get(result, 'core.getCoveoAuthentication');

  return {
    ...initialState,
    ...tokenInfo,
  };
};

export const useGetCoveoAuthentication = (options) => {
  const [queryResult, queryAction] = useQuery(GET_COVEO_AUTHENTICATION, {
    ...options,
    onCompleted: (result) => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
